import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteAbTest($input: DeleteAbTestInput!) {
    deleteAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
